<template>
  <div v-if="shoulShowIdentificationForm" class="columns">
    <div v-if="v.billingInfo.identificationType && shouldShowIdentificationType" class="column is-5">
      <div class="field">
        <label class="label">
          Tipo de identificación {{ isIdentificationTypeRequired ? '*' : '' }}
        </label>
        <div class="select control is-fullwidth">
          <select v-model.trim="v.billingInfo.identificationType.$model">
            <option
              v-for="(type, indexOption) in identificationTypes"
              :key="indexOption"
              :value="type"
            >
              {{ type.value }}
            </option>
          </select>
        </div>
        <div v-if="showIdentificationTypeMessage">
          <p class="help is-danger">Selecciona un tipo de identificación</p>
        </div>
      </div>
    </div>
    <div v-if="v.billingInfo.identification" :class="shouldShowFullWidthInput ? 'column is-12' : 'column is-7'">
      <div class="field">
        <label class="label"
          >Número de identificación {{ isIdentificationRequired ? '*' : '' }}</label>
        <div class="control">
          <input
            v-model.trim="v.billingInfo.identification.$model"
            class="input"
            :class="{
              error: shouldShowIdentificationError
            }"
            type="text"
            placeholder="Tu número de identificación"
            :disabled="shouldDisableIdentificationInput"
          />
        </div>
        <p v-if="showIdentificationMessage" class="help is-danger">
          Ingresa tu número de identificación
        </p>
        <p v-else-if="!v.billingInfo.identification.numeric" class="help is-danger">
          Ingresa un número de identificación válido
        </p>
        <p v-else-if="showInvalidCfFormat" class="help is-danger">
          La cédula física debe ser un valor numérico de 9 dígitos, sin ceros al inicio y sin guiones
        </p>
        <p v-else-if="!isIdentificationValid" class="help is-danger">
          Ingresa un formato de identificación válido
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import { VERSIONS } from '@/utils/constants'

const { COLOMBIA, ARGENTINA, PERU, MEXICO, REPUBLICA_DOMINICANA, COSTA_RICA } = VERSIONS

// Configuración de comportamientos por versión
const VERSION_BEHAVIORS = {
  // Versiones que muestran el formulario de identificación
  SHOW_IDENTIFICATION_FORM: [COLOMBIA, ARGENTINA, PERU, MEXICO, REPUBLICA_DOMINICANA, COSTA_RICA],

  // Versiones que NO muestran el selector de tipo de identificación
  HIDE_IDENTIFICATION_TYPE_SELECTOR: [MEXICO],

  // Versiones donde el input de identificación siempre está habilitado
  ALWAYS_ENABLE_IDENTIFICATION_INPUT: [MEXICO],

  // Versiones con validaciones específicas de identificación
  SPECIFIC_VALIDATIONS: [PERU, REPUBLICA_DOMINICANA, COSTA_RICA]
}

export default {
  name: 'IdentificationClient',
  inject: ['v'],
  computed: {
    applicationVersion: get('shop@shop.config.applicationVersion'),
    identificationTypes: get('config@identificationTypes'),
    shoulShowIdentificationForm() {
      return VERSION_BEHAVIORS.SHOW_IDENTIFICATION_FORM.includes(this.applicationVersion)
    },
    shouldShowIdentificationType() {
      return !VERSION_BEHAVIORS.HIDE_IDENTIFICATION_TYPE_SELECTOR.includes(this.applicationVersion)
    },
    shouldShowFullWidthInput() {
      // Si no se muestra el selector de tipo, el input ocupa todo el ancho
      return !this.shouldShowIdentificationType
    },
    shouldDisableIdentificationInput() {
      // Si la versión siempre debe tener el input habilitado, retorna false
      if (VERSION_BEHAVIORS.ALWAYS_ENABLE_IDENTIFICATION_INPUT.includes(this.applicationVersion)) {
        return false
      }
      // Para otras versiones, se deshabilita si no hay tipo seleccionado
      return !this.v.billingInfo.identificationType?.$model
    },
    isIdentificationRequired() {
      if (this.v.billingInfo.identification.required === undefined) return false
      return true
    },
    isIdentificationValid() {
      if (
        this.applicationVersion === PERU &&
        !this.v.billingInfo.identification.isValidDNIPeru
      ) return false
      if (
        this.applicationVersion === REPUBLICA_DOMINICANA &&
        (
          !this.v.billingInfo.identification.isValidRncDom ||
          !this.v.billingInfo.identification.isValidCedDom
        )
      ) return false
      if (
        this.applicationVersion === COSTA_RICA && (
          !this.v.billingInfo.identification.isValidCfCri ||
          !this.v.billingInfo.identification.isValidCjCri ||
          !this.v.billingInfo.identification.isValidDimexCri ||
          !this.v.billingInfo.identification.isValidPeCri ||
          !this.v.billingInfo.identification.isValidNiteCri
        )
      ) return false
      return true
    },
    isIdentificationTypeRequired() {
      if (this.v.billingInfo.identificationType.required === undefined) return false
      return true
    },
    shouldShowIdentificationError() {
      return (
        this.isIdentificationRequired &&
        this.v.billingInfo.identification.$dirty &&
        this.v.billingInfo.identification.$invalid
      )
    },
    showIdentificationMessage() {
      if (!this.isIdentificationRequired) return false
      return (
        this.v.billingInfo.identification.$dirty &&
        !this.v.billingInfo.identification.required
      )
    },
    showIdentificationTypeMessage() {
      if (!this.isIdentificationTypeRequired) return false
      return (
        this.v.billingInfo.identificationType.$dirty &&
        !this.v.billingInfo.identificationType.required
      )
    },
    showInvalidCfFormat() {
      if (this.applicationVersion !== COSTA_RICA) return false
      if (!this.v.billingInfo.identification.$dirty) return false
      if (!this.v.billingInfo.identificationType?.$model?.key === 'CF') return false

      return !this.v.billingInfo.identification.isValidCfCri
    }
  }
}
</script>

<style lang="scss" scoped></style>
